import React, { useRef } from 'react';
import useFullHeight from './useFullHeight';

type Props = {
  /** The page's own block class, before ContainerFixed */
  className: string;
  children?: React.ReactNode;
};

/** A page block at least as tall as the window */
const SubjectSiteContainerFixed: React.FC<Props> = ({
  className,
  children,
}) => {
  const blockRef = useRef<HTMLDivElement>(null);

  useFullHeight(blockRef);

  return (
    <div className={`${className} ContainerFixed`} ref={blockRef}>
      <div className="Inner">{children}</div>
    </div>
  );
};

export default SubjectSiteContainerFixed;
